import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TranslateService} from "@ngx-translate/core";
import {KYC} from "../Models/Kyc";
import {Workflow} from "../Models/Workflow";


@Injectable({
    providedIn: 'root'
})

export class DocumentService {

    static readonly STATUS_PENDING = 0;
    static readonly STATUS_SIGNED = 2;
    static readonly STATUS_REJECTED = 4;
    static readonly STATUS_OBSERVER = 5;
    static readonly STATUS_REJECTED_OBSERVER = 6;

    constructor(
        private translate: TranslateService
    ) {
    }


    getKycMode(receiver: any) {
        if (receiver && receiver.kyc) {
                return receiver.kyc.mode;
        }
        return KYC.NONE;
    }



    getReceivers(document) {
        let receivers = [];
        if (Array.isArray(document.receivers)) {
            receivers = document.receivers;
        } else if (Array.isArray(document.cache_receivers)) {
            receivers = document.cache_receivers;
        }
        return receivers;
    }





    getSignatureTypeText(document: any, receiver: any) {
        const words = [];
        words.push('SIGNATURE_TYPE.' + document.signature_type);

        switch (this.getKycMode(receiver)) {
            case KYC.MANUAL:
                words.push('TIPOS_FIRMA.KYC_MANUAL');
                break;
            case KYC.AUTO:
                words.push('TIPOS_FIRMA.KYC_AUTO');
                break;
            case KYC.CUSTOM:
                words.push('TIPOS_FIRMA.KYC_CUSTOM');
                break;
        }


        let text = '';
        words.forEach((word, i, wordlist) => {
            this.translate.get(word).subscribe(data => {
                text += data;
                if (i !== wordlist.length - 1) {
                    text += ' + ';
                }
            });
        });
        return text;
    }

    isPartialAudit(document) {
        return document.status != DocumentService.STATUS_SIGNED;
    }

    statusText(document) {
        let text = 'DOCUMENT_STATUS.';
        if (!document.receivers) {
            return text + 'INVALID';
        }
        if (document.expired) {
            return text + 'EXPIRED';
        }

        switch (document.status) {
            case 2:

                if (document.signature_type === Workflow.SIGNATURE_EMAIL_CERTIFICATE) {
                    text += 'DOWNLOADED'
                } else {
                    text += 'SIGNED';
                }

                break;
            case 4:
                text += 'REJECTED';
                break;
            case 5:
                text += 'PENDING_OBSERVER';
                break;
            case 6:
                text += 'PENDING_OBSERVER';
                break;
            default:
                text += 'PENDING';
                break;
        }

        return text;
    }

    auditText(document) {
        let text = 'AUDIT.';
        if (!document.receivers) {
            return text + 'INVALID';
        }
        if (document.expired) {
            return text + 'EXPIRED';
        }

        if (document.status == DocumentService.STATUS_SIGNED) {
            return text + 'SIGNED'
        }

        if ([DocumentService.STATUS_REJECTED, DocumentService.STATUS_REJECTED_OBSERVER]) {
            return text + 'REJECTED'
        }
        return text + 'PENDING';
    }

    // timestamp en el que ha firmado el receiver
    getSignedAt(receiver) {
        if (receiver.evidences && receiver.evidences.doc_sign && receiver.evidences.doc_sign[0] && receiver.evidences.doc_sign[0].timestamp) {
            return receiver.evidences.doc_sign[0].timestamp
        }
        if (receiver.status === DocumentService.STATUS_SIGNED) {
            if (receiver.evidences && receiver.evidences.otp_received && receiver.evidences.otp_received[0] && receiver.evidences.otp_received[0].timestamp) {
                return receiver.evidences.otp_received[0].timestamp;
            }
        }

        return 0;

    }
    
}
